export default [
    {
        label: 'Efectivo',
        value: 'efectivo',
        disabled: false,
        id: 'efectivo',
    },
    {
        label: 'Tarjeta Débito',
        value: 'debito',
        disabled: false,
        id: 'tarjeta_debito'
    },
    {
        label: 'Tarjeta Crédito',
        value: 'credito',
        disabled: false,
        id: 'tarjeta_credito'
    },
    {
        label: 'Cheque',
        value: 'cheque',
        disabled: false,
        id: 'cheque'
    },
    {
        label: 'Crédito Cliente',
        value: 'credito_cliente',
        disabled: true,
        id: 'credito_cliente'
    },
    {
        label: 'Depósito',
        value: 'deposito',
        disabled: false,
        id: 'deposito'
    },
    {
        label: 'Nota de Crédito',
        value: 'nota_credito',
        disabled: false,
        id: 'nota_credito'
    },
    {
        label: 'Abono',
        value: 'abono',
        disabled: false,
        id: 'abono'
    },
    {
      label: 'Saldo Favor',
      value: 'saldo_favor',
      disabled: false,
      id: 'saldo_favor'
    }
]


